import { PageMeta } from '../../../shared/components';
import { TemplateManagerPanel } from '../../quality-formulas/components/TemplateManagerPanel';
import '../../quality-formulas/components/qualitySpecsWorkbench.css';

export const TemplateManagerPage: React.FC = () => (
  <div className="slds-p-bottom_x-large slds-p-horizontal_medium slds-p-top_small" style={{ width: '100%' }}>
    <PageMeta
      description="Manage reusable, spec-scoped Quality Adjustment templates contracts can load as a starting point."
      title="Template Manager"
    />
    <TemplateManagerPanel />
  </div>
);
